import { doc, getDoc } from 'firebase/firestore';

import { popup } from '../../../../addons/Popup';
import { firestore } from '../../../../App/firebase';

export default async (formId: string) => {
  const formDoc = await getDoc(doc(firestore, "forms_v2", formId));
  if (!formDoc.exists()) return;

  const invoiceDoc = await getDoc<any>(formDoc.data()!.invoice);
  if (!invoiceDoc.exists()) return;

  console.log(invoiceDoc.data()!.legal);
  const invoiceData = invoiceDoc.data()!;

  if (invoiceData.processed !== true) {
    popup(
      "Fatura hala işleniyor olabilir, daha sonra tekrar deneyiniz. İşlem No: " +
        invoiceData.jobId
    );
    return;
  }

  const invoiceUUID = invoiceData.legal?.uuid;
  if (typeof invoiceUUID !== "string") return;

  window.open(
    `https://earsiv.efinans.com.tr/earsiv/goruntule.jsp?vkn=6310084958&email=1&uuid=${invoiceUUID}`
  );
};
